import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hero-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-title" }
const _hoisted_5 = { class: "hero-subtitle" }
const _hoisted_6 = { class: "hero-actions" }
const _hoisted_7 = { class: "hero-features" }
const _hoisted_8 = { class: "feature-item" }
const _hoisted_9 = { class: "feature-item" }
const _hoisted_10 = { class: "feature-item" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "image-badge" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "qr-popup-content" }
const _hoisted_15 = { class: "qr-title" }
const _hoisted_16 = { class: "qr-code-container" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "qr-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('home.heroTitle')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('home.heroSubtitle')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_button, {
            class: "gold-button",
            size: "large",
            onClick: _ctx.goToVerification
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "certificate" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('home.verifyNow')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_van_button, {
            class: "blue-outline-button",
            size: "large",
            onClick: _ctx.goToReport
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, { name: "shield-o" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('home.reportFake')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_icon, {
              name: "checked",
              class: "feature-icon"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.quickVerification')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_icon, {
              name: "checked",
              class: "feature-icon"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.security')), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_icon, {
              name: "checked",
              class: "feature-icon"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.realTimeUpdates')), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heroInfoList, (heroInfo) => {
        return (_openBlock(), _createElementBlock("div", {
          key: heroInfo.id,
          class: "hero-image"
        }, [
          _createElementVNode("img", {
            src: heroInfo?.coverPic,
            alt: _ctx.$t('home.heroImageAlt'),
            loading: "lazy"
          }, null, 8, _hoisted_11),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "badge-content",
              onClick: _withModifiers(($event: any) => (_ctx.handleClickCodeScan(heroInfo)), ["stop"])
            }, [
              _createVNode(_component_van_icon, { name: "scan" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.scanToExperience')), 1)
            ], 8, _hoisted_13)
          ])
        ]))
      }), 128)),
      _createVNode(_component_van_popup, {
        show: _ctx.isCodeScan,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCodeScan) = $event)),
        round: "",
        closeable: "",
        position: "center",
        style: { width: '90%', maxWidth: '320px' },
        onClickClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCodeScan = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('home.scanToExperience')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                src: _ctx.selectedProduct?.feedbackPic,
                alt: "QR Code",
                class: "qr-code-image"
              }, null, 8, _hoisted_17)
            ]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('home.scanDescription')), 1),
            _createVNode(_component_van_button, {
              class: "close-button",
              type: "primary",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCodeScan = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}